module.exports = __webpack_public_path__ + "static/media/feedback_sub_date_sort_btn.b06c3fe7.svg";